import { createApiClient } from "#/shared/api/client";

/**
 * Maps a record's internal link to the admin endpoint describing it:
 * `"sparkle://pages/12#body"` → `"/admin/pages/12/meta_data.json"`.
 *
 * @param {String} sparkleUrl
 * @returns {String}
 */
export function resolveMetaDataUrl(sparkleUrl) {
  const path = String(sparkleUrl)
    .replace(/^sparkle:\/\//, "/")
    .replace(/#.*/, "");

  return `/admin${path}/meta_data.json`;
}

export function createMetaDataApi() {
  const api = createApiClient({ parse: false });

  return {
    /**
     * Returns `{iconName, label, url}` for the record the internal link names, or null when the
     * record cannot be described — an unroutable link, or a request that fails. `iconName` is the
     * admin icon-manifest key for the record's controller, `"locations"` → `"location"`.
     *
     * @param {String} sparkleUrl
     * @returns {Promise<Object|null>}
     */
    findTarget: async (sparkleUrl) => {
      if (!sparkleUrl) {
        return null;
      }

      try {
        const data = await api.get(resolveMetaDataUrl(sparkleUrl));

        // An auth redirect answers 200 with an HTML body, which describes no record.
        if (typeof data !== "object" || data === null) {
          return null;
        }

        return { iconName: data.icon_name ?? "", label: data.label ?? "", url: data.url ?? "" };
      } catch {
        return null;
      }
    },
  };
}
